import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomDateRangePicker } from '../_helper/custom-date-range-picker';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { DataSharingService } from '../_services/data-sharing.service';

@Component({
  selector: 'ppr-ppr-home-page',
  templateUrl: './ppr-home-page.component.html',
  styleUrls: ['./ppr-home-page.component.css']
})
export class PprHomePageComponent implements OnInit {

  //TODO: this should be dynamic maybe?
  readonly yearlyReportDateRange: string = '01-01-2020to31-12-2020';

  submissionForm: FormGroup;

  customRangeStartDate: string;
  customRangeEndDate: string;

  dateRangePickerProperties: CustomDateRangePicker;
  public whitebranding : any;
  public quarterValues: Array<String> = [];

  rootScope: any;
  user: any;

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    private dataSharingService: DataSharingService) { }

  ngOnInit() {
    this.getRootScopeAndSetValues();
    this.setQuarterValues();
    this.initializeForm();
    this.setDateRangePickerProperties();
  }

  getRootScopeAndSetValues() {
    this.rootScope = this.dataSharingService.rootScope.getValue();
    if (this.rootScope) {
      this.whitebranding = this.rootScope.wb || this.rootScope.$$childHead.$parent.wb;
      this.user = this.rootScope.$$childHead.user;
    }
  }

  initializeForm() {
    //TODO: We might have to look in what we should do in the case of multiple accounts assigned to the same user
    this.submissionForm = this.formBuilder.group({
      accountNumber: [{ value: this.user.account, disabled: !this.dataSharingService.isPPRAdmin() }, Validators.required],
      quarter: [this.quarterValues[0]],
      dateRange: ['']
    });
  }

  setDateRangePickerProperties() {
    this.dateRangePickerProperties = new CustomDateRangePicker(this.translate);
  }

  onSubmit(buttonType: string) {
    if (this.submissionForm.invalid) { return; }

    let queryParams: any = {};
    if (this.dataSharingService.isPPRAdmin()) { queryParams.accountNumber = this.submissionForm.get('accountNumber').value; }
    if (buttonType.startsWith('yearlyReport')) {
      queryParams.dateRange = this.yearlyReportDateRange;
      if (buttonType === 'yearlyReportBE') {
        this.generateYearlyReportBE(queryParams);
      } else {
        this.generateYearlyReport(queryParams);
      }
    } else {
      this.isDateRangeSelected() ? this.generateDateRangeAssetManagerReport(queryParams) : this.generateQuarterlyAssetManagerReport(queryParams);
    }
  }

  generateQuarterlyAssetManagerReport(queryParams: any) {
    queryParams.quarter = this.submissionForm.get('quarter').value;
    this.router.navigate(['/ppr/generate/assetManagersReport'], { queryParams: queryParams });
  }

  generateDateRangeAssetManagerReport(queryParams: any) {
    queryParams.dateRange = this.customRangeStartDate + 'to' + this.customRangeEndDate;
    this.router.navigate(['/ppr/generate/assetManagersReport'], { queryParams: queryParams });
  }

  generateYearlyReport(queryParams: any) {
    queryParams.dateRange = this.yearlyReportDateRange;
    this.router.navigate(['/ppr/generate/yearlyReport'], { queryParams: queryParams });
  }

  generateYearlyReportBE(queryParams: any) {
    queryParams.dateRange = this.yearlyReportDateRange;
    this.router.navigate(['/ppr/generate/yearlyReport/BE'], { queryParams: queryParams });
  }

  isDateRangeSelected() {
    return this.customRangeStartDate && this.customRangeEndDate;
  }

  datesUpdated(range: any) {
    if (range.startDate && range.endDate) {
      this.customRangeStartDate = (<moment.Moment>range.startDate).format('DD-MM-YYYY');
      this.customRangeEndDate = (<moment.Moment>range.endDate).format('DD-MM-YYYY');
      this.submissionForm.get('quarter').setValue('');
    } else {
      this.customRangeStartDate = null;
      this.customRangeEndDate = null;
    }
  }

  quarterUpdated(quarter: string) {
    this.submissionForm.get('dateRange').setValue('');
  }

  //TODO: To be implemented
  checkedDownloadPDF() {
  }

  setQuarterValues() {
    let currentYear = this.getCurrentYear();
    let previousYear = currentYear - 1;

    switch (this.getCurrentQuarter()) {
      case 1:
        this.quarterValues = [
          "Q1 " + currentYear,
          "Q4 " + previousYear,
          "Q3 " + previousYear,
          "Q2 " + previousYear
        ]
        break
      case 2:
        this.quarterValues = [
          "Q2 " + currentYear,
          "Q1 " + currentYear,
          "Q4 " + previousYear,
          "Q3 " + previousYear
        ]
        break
      case 3:
        this.quarterValues = [
          "Q3 " + currentYear,
          "Q2 " + currentYear,
          "Q1 " + currentYear,
          "Q4 " + previousYear
        ]
        break
      case 4:
        this.quarterValues = [
          "Q4 " + currentYear,
          "Q3 " + currentYear,
          "Q2 " + currentYear,
          "Q1 " + currentYear
        ]
        break

    }
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }

  getCurrentQuarter() {
    return moment().quarter();
  }
}

